/* MyKidss PDP micro UX. No cart logic is duplicated; the original form remains the source of truth. */
(function () {
  'use strict';
  function init() {
    var gallery = document.querySelector('.main-product-grid .main-product-slider');
    var count = document.querySelector('media-gallery [data-mykidss-gallery-current]');
    if (gallery && count && window.jQuery) {
      window.jQuery(gallery).on('select.flickity change.flickity', function () {
        var instance = window.jQuery(gallery).data('flickity');
        if (instance) count.textContent = String(instance.selectedIndex + 1);
      });
      var instance = window.jQuery(gallery).data('flickity');
      if (instance) count.textContent = String(instance.selectedIndex + 1);
    }
    /* Gallery Width Fix v1: Flickity must measure the INNER gallery width.
       Do not reinitialize the slider or replace its selected slide. */
    if (gallery && window.ResizeObserver && window.jQuery) {
      var galleryHost = gallery.closest('.product-slide-box') || gallery;
      var lastGalleryWidth = 0;
      var widthSyncQueued = false;
      function syncGalleryWidth() {
        widthSyncQueued = false;
        if (window.innerWidth > 767) return;
        var currentWidth = Math.round(gallery.getBoundingClientRect().width);
        var instance = window.jQuery(gallery).data('flickity');
        if (!currentWidth || !instance || currentWidth === lastGalleryWidth) return;
        lastGalleryWidth = currentWidth;
        window.jQuery(gallery).flickity('resize');
      }
      function queueGalleryWidthSync() {
        if (widthSyncQueued) return;
        widthSyncQueued = true;
        window.requestAnimationFrame(syncGalleryWidth);
      }
      var galleryResizeObserver = new ResizeObserver(queueGalleryWidthSync);
      galleryResizeObserver.observe(galleryHost);
      window.addEventListener('load', queueGalleryWidthSync, {once:true});
      queueGalleryWidthSync();
    }
    var form = document.querySelector('.main-product-content product-form form[data-type="add-to-cart-form"]');
    if (!form) return;
    var original = form.querySelector('button[name="add"]');
    if (!original) return;
    var bar = document.createElement('div');
    bar.className = 'mykidss-pdp-sticky';
    bar.setAttribute('aria-label', 'Product purchase action');
    var button = document.createElement('button');
    button.type = 'button';
    button.textContent = original.textContent.trim();
    bar.appendChild(button);
    document.body.appendChild(bar);
    var media = window.matchMedia('(max-width: 767px) and (min-height: 561px)');
    function update() {
      var rect = original.getBoundingClientRect();
      var passed = rect.bottom < 0;
      var drawer = document.querySelector('cart-drawer');
      var drawerOpen = !!(drawer && (drawer.classList.contains('active') || drawer.classList.contains('is-open') || drawer.classList.contains('open')));
      var modalOpen = Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"]')).some(function (el) { var st = getComputedStyle(el); return st.display !== 'none' && st.visibility !== 'hidden' && el.getBoundingClientRect().width > 0; });
      var keyboardOpen = window.visualViewport && window.visualViewport.height < window.innerHeight * .72;
      var visible = media.matches && passed && !drawerOpen && !modalOpen && !keyboardOpen;
      bar.classList.toggle('is-visible', !!visible);
      button.disabled = original.disabled;
      button.textContent = original.textContent.trim();
    }
    button.addEventListener('click', function () {
      if (original.disabled) return;
      original.click();
      bar.classList.remove('is-visible');
    });
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    if (window.visualViewport) window.visualViewport.addEventListener('resize', update);
    new MutationObserver(update).observe(original, {attributes:true, childList:true, subtree:true});
    document.addEventListener('click', function () { window.requestAnimationFrame(update); }, true);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
